import { requestDelete, requestGet, requestPost } from '@configs/quiz';
import { showLoading } from '@store/actions';
import { getUserToken } from '@utils';
import { GET_ALL_BANK_SOAL, GET_BANK_SOAL, GET_ONE_BANK_SOAL } from '@type';
import { CLEAR_BANK_SOAL, CREATE_BANK_SOAL, DELETE_BANK_SOAL, REVIEW_PAKET_SOAL } from '../../../../constants/initType';
import { requestPatch } from '../../../../configs/quiz';
import { AxiosInject, notificationOverride } from '../../../../utils/Utils';
import { BASE_API_URL, BASE_QUIZ } from '../../../../constants/initHttp';

export const getAllQuiz = () => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestGet('quiz', null, getUserToken());
    dispatch({ type: GET_ALL_BANK_SOAL, value: rest.data });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

export const getQuizByParam = (params) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestGet('quiz', params, getUserToken());
    dispatch({
      type: GET_BANK_SOAL,
      value: rest.data,
      meta: rest.meta,
    });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

export const createBankSoal = (data) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestPost('quiz', data, getUserToken());

    // dispatch({
    //     type: CREATE_BANK_SOAL,
    //     value: rest.code === 200 ? true : false,
    // });
    dispatch(showLoading(false));
    return rest.data;
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

export const duplicateBankSoal = (id) => async (dispatch) => {
  dispatch(showLoading(true));
  const httpInjector = AxiosInject(BASE_QUIZ, 'Bearer', getUserToken());
  return await httpInjector
    .post(`quiz/duplicate/${id}`, {
      status: 'draft',
    })
    .then((r) => r.data)
    .catch((r) => {
      throw new Error(r);
    })
    .finally(() => dispatch(showLoading(false)));
};

export const createQuestion = (data, type) => async (dispatch) => {
  if (type === 'finish') {
    dispatch(showLoading(true));
  }
  try {
    const rest = await requestPost('question', data, getUserToken());

    if (type === 'finish') {
      dispatch({
        type: CREATE_BANK_SOAL,
        value: rest.code === 200,
      });
    }
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};
export const updateBankSoal = (data, type) => async (dispatch) => {
  if (type === 'finish') {
    dispatch(showLoading(true));
  }
  try {
    const rest = await requestPatch('quiz', data, getUserToken());
    if (type === 'finish') {
      dispatch({
        type: CREATE_BANK_SOAL,
        value: rest.code === 200,
      });
    }
    dispatch({ type: 'PATCH_BANK_SOAL', value: rest?.data?.questions });
    return rest?.data?.questions;
  } catch (error) {
    notificationOverride({
      title: 'Mohon Maaf!',
      description: 'Soal sudah digunakan untuk ujian!',
      type: 'error',
    });
  }
  dispatch(showLoading(false));
};

export const cacheBankSoal = (data) => {
  // quiz/draft-cache
  const httpInjector = AxiosInject(BASE_QUIZ, 'Bearer', getUserToken());
  return httpInjector
    .post('quiz/draft-cache', data)
    .then((r) => r.data)
    .catch(() => {
      console.log('drafted failed');
    });
};

export const patchStatus = ({ id, status = 'draft' }) => {
  // quiz/draft-cache
  const httpInjector = AxiosInject(BASE_QUIZ, 'Bearer', getUserToken());
  return httpInjector
    .patch('quiz/status', {
      id,
      status,
    })
    .then((r) => r.data)
    .catch(() => {
      console.log('drafted failed');
    });
};

export const getCacheBankSoal = (id) => {
  const httpInjector = AxiosInject(BASE_QUIZ, 'Bearer', getUserToken());
  return httpInjector
    .get('quiz/draft-cache', {
      params: {
        key: id,
      },
    })
    .then((r) => r.data)
    .catch(() => {
      console.log('drafted failed');
    });
};

export const deleteBankSoal = (id) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestDelete(`quiz/${id}`, null, getUserToken());
    dispatch({
      type: DELETE_BANK_SOAL,
      value: rest.code === 200,
    });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};
export const deleteQuestion = (id) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    await requestDelete(`question/${id}`, null, getUserToken());
    // dispatch({
    //     type: DELETE_BANK_SOAL,
    //     value: rest.code === 200 ? true : false,
    // });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

// Proses lampiran di bank soal
export const uploadFileBankSoal = (data) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestPost('quiz/file/upload', data, getUserToken());
    dispatch(showLoading(false));
    return rest;
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

export const getQuizByID = (id) => async (dispatch) => {
  dispatch(showLoading(true));
  try {
    const rest = await requestGet(`quiz/${id}`, null, getUserToken());
    dispatch({ type: GET_ONE_BANK_SOAL, value: rest.data });
  } catch (error) {
    // notification.error({
    //   message: 'Mohon Maaf!',
    //   description: 'Silahkan Hubungi Customer Service Kami',
    // });
  }
  dispatch(showLoading(false));
};

export const getAllSchool = () => {
  const httpInjector = AxiosInject(BASE_API_URL, '', getUserToken());
  return async (dispatch) => {
    dispatch(showLoading(true));
    return await httpInjector
      .get('/v2/schools')
      .then((r) => {
        dispatch(showLoading(false));
        return r.data;
      })
      .catch((r) => {
        dispatch(showLoading(false));
        throw new Error(r);
      });
  };
};

export const shareQuiz = (payload) => {
  const httpInjector = AxiosInject(BASE_QUIZ, 'Bearer', getUserToken());
  return async (dispatch) => {
    dispatch(showLoading(true));
    return await httpInjector
      .post('quiz/share', payload)
      .then((r) => {
        dispatch(showLoading(false));
        return r.data;
      })
      .catch((r) => {
        dispatch(showLoading(false));
        throw new Error(r);
      });
  };
};

export const getQuestionHistory = (params) => {
  const httpInjector = AxiosInject(BASE_QUIZ, 'Bearer', getUserToken());
  return async (dispatch) => {
    dispatch(showLoading(true));
    return await httpInjector
      .get('question/history', { params })
      .then((r) => {
        dispatch(showLoading(false));
        return r.data;
      })
      .catch((r) => {
        dispatch(showLoading(false));
        throw new Error(r);
      });
  };
};

// Proses review paket soal
export const reviewPaketSoal = (data) => async (dispatch) => {
  const updatedSteps = data.steps.map((step) => {
    const questionKey = `question_${step.key}`;
    const pointKey = `point_${step.key}`;
    const explanationKey = `explanation_${step.key}`;
    const typeKey = `type_${step.key}`;
    const answerOptionsKey = `answer_options_${step.key}`;
    const selectedAnswerKey = `selected_answer_${step.key}`;
    const answerKey = `answer_${step.key}`;

    let updatedAnswerOptions = data.changedValues[answerOptionsKey]
      ? data.allValues[answerOptionsKey]
      : step.answer_options;

    if (data.changedValues[selectedAnswerKey] !== undefined) {
      if (step.question_type === 3) {
        updatedAnswerOptions = [
          {
            value: 'Benar',
            is_correct_answer: data.changedValues[selectedAnswerKey] === 'Benar',
          },
          {
            value: 'Salah',
            is_correct_answer: data.changedValues[selectedAnswerKey] === 'Salah',
          },
        ];
        updatedAnswerOptions = updatedAnswerOptions.map((option) => ({
          ...option,
          is_correct_answer: option.value === data.changedValues[selectedAnswerKey],
        }));
      } else {
        updatedAnswerOptions = updatedAnswerOptions.map((option, idx) => ({
          ...option,
          is_correct_answer: Array.isArray(data.changedValues[selectedAnswerKey])
            ? data.changedValues[selectedAnswerKey].includes(idx)
            : data.changedValues[selectedAnswerKey] === idx,
        }));
      }
    }

    if (data.changedValues[answerKey]) {
      updatedAnswerOptions = [
        {
          value: data.allValues[answerKey],
          is_correct_answer: true,
        },
      ];
    }

    return {
      ...step,
      question: data.allValues[questionKey] || step.question,
      point: data.allValues[pointKey] || step.point,
      explanation: data.allValues[explanationKey] || step.explanation,
      question_type: data.allValues[typeKey] !== undefined ? parseInt(data.allValues[typeKey], 10) : step.question_type,
      answer_options: updatedAnswerOptions,
    };
  });

  dispatch({
    type: REVIEW_PAKET_SOAL,
    payload: {
      ...data,
      steps: updatedSteps,
    },
  });
  return updatedSteps;
};

// clear action reducers
export const clearCreateBankSoal = () => ({
  type: CREATE_BANK_SOAL,
  value: false,
});

export const clearBankSoal = () => ({
  type: CLEAR_BANK_SOAL,
});
